import { type FunctionComponent } from 'react';
import { trackClearAllFacets } from '../../../helpers/search-helper/search-analytics.helper';
import { useSearchResults } from '../../../hooks/apollo/search/search.hooks';
import { TextButton } from '../../buttons';

export type NoFilteredSearchResultsProps = {};

export const NoFilteredSearchResults: FunctionComponent<NoFilteredSearchResultsProps> = () => {
	const { clearFacets, query, results } = useSearchResults();
	const selectedFacetGroups = results?.selectedFacetGroups ?? [];
	const clearAllFacets = () => {
		trackClearAllFacets(selectedFacetGroups, query);
		clearFacets();
	};

	return (
		<div className="ml3-l mb6" data-automation="no-filtered-results" data-testid="no-filtered-results">
			<h2>No results with current filters</h2>
			<div>
				You may find more results if you <TextButton onClick={clearAllFacets}>clear all filters</TextButton>, or remove filters
				individually.
			</div>
		</div>
	);
};
